(function () {
  if (!customElements.get("accordion-list")) {
    class AccordionList extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: "open" });
      }

      connectedCallback() {
        const gap = this.getAttribute("gap") || 0;
        
        this.shadowRoot.innerHTML = `
          <style>
            :host {
              display: flex;
              flex-direction: column;
              gap: ${gap}px;      
            }
          </style>
          <slot></slot>
        `;

        this.addEventListener("toggle", this.onToggle.bind(this));
      }

      onToggle(e) {
        const openedItem = e.target;
        
        this.querySelectorAll('accordion-item').forEach(item => {
          if (item !== openedItem && item.hasAttribute('open')) {
            item.removeAttribute('open');
          }
        });
      }
    }

    customElements.define("accordion-list", AccordionList);
  }

  if (!customElements.get("accordion-item")) {
    class AccordionItem extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: "open" });
      }

      static get observedAttributes() {
        return ["open"];
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === "open") {
          this.updateState();
        }
      }

      connectedCallback() {
        const title = this.getAttribute("title");
        const content = this.getAttribute("content");
        const open = this.hasAttribute("open");

        this.shadowRoot.innerHTML = `
          <style>
            :host {
              display: block;
              border: 1px solid #D1D1D6;
              border-radius: 4px;
              overflow: hidden;
              transition: border-color 0.3s linear;
              scroll-margin-top: 100px;
            }

            :host([open]) {
              border-color: transparent; 
            }

            .header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 10px 20px;
              background-color: #ffffff;
              cursor: pointer;
              line-height: 1;
            }
    
            .title {
              user-select: none;
              display: block;
              font-size: 16px;
              line-height: 24px;
              font-weight: 700;
            }

            .icon {
              fill: #000000;
              transition: transform 0.2s linear;
            }
    
            :host([open]) .header {
              color: #ffffff;
              background-color: #F13C20;
            }

            :host([open]) .icon {
              fill: #ffffff;
              transform: rotate(180deg);
            }
            
            .content {
              max-height: 0;
              overflow: hidden;
              transition: max-height 0.2s linear, padding 0.2s linear;
              padding-inline: 20px;
              background-color: #F2F2F7;
            }

            .content p {
              margin: 0;
            }

            .content img {
              max-width: 100%;
            }

            .action {
              display: flex;
              align-items: center;
              gap: 16px;
            }

            .link {
              display: flex;
              background: #ffffff;
              border-radius: 50%;
              width: 32px;
              height: 32px;
              align-items: center;
              justify-content: center;
            }
          </style>
          <div class="header">
            <div class="title">
              ${title}
            </div>

            <div class="action">
              <a class="link" href="#123">
                <svg  width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.70454 2.15301C9.95297 -0.0954681 13.5985 -0.0954681 15.8469 2.15301C18.0954 4.40144 18.0954 8.04693 15.8469 10.2954L14.9216 11.2206C14.4106 11.7317 13.5821 11.7317 13.0711 11.2206C12.5601 10.7097 12.5601 9.88112 13.0711 9.37013L13.9964 8.44485C15.2228 7.2184 15.2228 5.22997 13.9964 4.00352C12.7699 2.77712 10.7815 2.77712 9.55505 4.00352L8.62977 4.9288C8.11878 5.43984 7.29025 5.43984 6.77926 4.9288C6.26822 4.41781 6.26822 3.58928 6.77926 3.07829L7.70454 2.15301ZM11.2205 6.77936C11.7316 7.29035 11.7316 8.11888 11.2205 8.62986L8.62977 11.2206C8.11878 11.7317 7.29025 11.7317 6.77926 11.2206C6.26822 10.7097 6.26822 9.88112 6.77926 9.37013L9.37003 6.77936C9.88102 6.26832 10.7096 6.26832 11.2205 6.77936ZM4.83617 6.87189C5.34721 7.38288 5.34721 8.21141 4.83617 8.7224L4.00342 9.55514C2.77702 10.7816 2.77702 12.77 4.00342 13.9965C5.22987 15.2229 7.2183 15.2229 8.44475 13.9965L9.2775 13.1637C9.78849 12.6527 10.617 12.6527 11.128 13.1637C11.639 13.6747 11.639 14.5033 11.128 15.0142L10.2953 15.847C8.04683 18.0955 4.40134 18.0955 2.15291 15.847C-0.0955673 13.5986 -0.0955673 9.95306 2.15291 7.70464L2.98566 6.87189C3.49665 6.36085 4.32518 6.36085 4.83617 6.87189Z" fill="#222222"/>
                </svg>
              </a>

              <svg class="icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L12 10.4142L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29289C11.6834 7.90237 12.3166 7.90237 12.7071 8.29289L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071Z" fill="current"/>
              </svg>
            </div>
          </div>
          <div class="content">${content}</div>
        `;

        this.shadowRoot
          .querySelector(".header")
          .addEventListener("click", () => {
            this.toggle();

            if (gtag) {
              gtag("event", "faq_click", {
                event_label: title,
                search_term: document.querySelector(".search-input").value.trim() || null
              });
            }
          });

        this.shadowRoot
          .querySelector(".link")
          .addEventListener("click", (e) => this.copy(e));

        if (open) {
          this.updateState();
        }

        if (window.location.hash == "#" + this.id) {
          this.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
          });
          this.setAttribute("open", "");
        }
      }

      getTitle() {
        return this.shadowRoot.querySelector(".title").textContent;
      }

      getContent() {
        return this.shadowRoot.querySelector(".content").textContent;
      }

      checkKeyword(value) {
        return (this.getAttribute("keywords")?.split(",") || []).some(kw => kw.includes(value));
      }

      toggle() {
        const isOpen = this.hasAttribute("open");

        if (isOpen) {
          this.removeAttribute("open");
        } else {
          this.setAttribute("open", "");

          this.shadowRoot.dispatchEvent(new CustomEvent('toggle', { 
            bubbles: true,
            composed: true
          }));
        }
      }

      copy(e) {
        e.preventDefault();
        e.stopPropagation();

        window.navigator.clipboard.writeText(`https://trendingcustom.com/pages/faqs/${this.getAttribute("category")}#${this.id}`)
      }

      updateState() {
        const content = this.shadowRoot.querySelector('.content');
        
        if (this.hasAttribute('open')) {
          content.style.maxHeight = content.scrollHeight + "px";
          content.style.paddingBlock = "20px";
        } else {
          content.style.maxHeight = "0";
          content.style.paddingBlock = "0";
        }
      }
    }

    customElements.define("accordion-item", AccordionItem);
  }

  let faqs = [];

  const data = JSON.parse(document.querySelector("#all-faq").textContent);
  const categories = data.categories;
  categories.forEach(c => c.faq.forEach(f => faqs.push({...f, category: {id: c.id, title: c.title, url: c.url}})));

  faqs = new Fuse(faqs, {
    keys: [
      'answer',
      {
        name: 'question',
        weight: 2
      },
      {
        name: 'keywords',
        weight: 3
      }
    ],
    includeScore: true,
    minMatchCharLength: 3,
    threshold: 0.3
  });

  if (document.querySelector(".search-input")) {
    const input = document.querySelector(".search-input");

    input.addEventListener("input", function(e) {
      const value = e.target.value.trim();

      const featuredQuestions = document.querySelector(".faq-featured-questions")
      const categoryQuestions = document.querySelector(".faq-category-questions")
      
      if (value.length > 0) {
        const results = faqs.search(value);
        const resultIds = results.map(record => String(record.item.id));
        
        featuredQuestions && (featuredQuestions.style.display = "none");
        categoryQuestions && (categoryQuestions.style.display = "none");
        document.querySelector(".faq-search-list").style.display = "block";

        document.querySelectorAll(".faq-search-list accordion-item").forEach(item => {
          if (resultIds.includes(item.id.replace("faqx-", ""))) {
            item.removeAttribute("hidden");
          } else {
            item.setAttribute("hidden", "");
          }
        });

        document.querySelectorAll(".faq-search-list .faq-category").forEach(category => {
          const items = category.querySelectorAll("accordion-item");

          for (let item of items) {
            if (!item.hasAttribute("hidden")) {
              category.removeAttribute("hidden");
              return;
            };
          }

          category.setAttribute("hidden", "");
        });

        const categories = document.querySelectorAll(".faq-search-list .faq-category");
        let isEmpty = true;

        for (let category of categories) {
          if (!category.hasAttribute("hidden")) {
            isEmpty = false;
          }
        }

        if (isEmpty) {
          document.querySelector(".faq-search-empty").style.display = "flex";
        } else {
          document.querySelector(".faq-search-empty").style.display = "none";
        }
      } else {
        featuredQuestions && (featuredQuestions.style.display = "block");
        categoryQuestions && (categoryQuestions.style.display = "block");
        document.querySelector(".faq-search-list").style.display = "none";
      }
    })

    input.addEventListener("blur", function() {
      if (input.value.trim().length > 0) {
        gtag("event", "search", {
          search_term: input.value.trim()
        })
      } 
    });
  }

  if (document.querySelector(".faq-contact-form a")) {
    document.querySelector(".faq-contact-form a").addEventListener("click", function() {
      gtag("event", "cta_click", {
        event_label: "Contact",
        search_term: document.querySelector(".search-input").value.trim() || null
      })
    });
  }

  if (document.querySelector(".faq-search-empty a")) {
    document.querySelector(".faq-search-empty a").addEventListener("click", function() {
      gtag("event", "cta_click", {
        event_label: "Contact",
        search_term: document.querySelector(".search-input").value.trim() || null
      })
    });
  }

  document.querySelectorAll(".faq-categories .category").forEach((el) => {
    el.addEventListener("click", function() {
      gtag("event", "cta_click", {
        event_label: el.querySelector(".category-title").textContent,
        search_term: document.querySelector(".search-input").value.trim() || null
      });
    });
  });
})();
